var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 141,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 7C35.7114 7 7 35.7114 7 71C7 106.289 35.7114 135 71 135C106.289 135 135 106.289 135 71C135 35.7114 106.289 7 71 7ZM71 128.905C39.0714 128.905 13.0953 102.929 13.0953 71C13.0953 39.0714 39.0714 13.0953 71 13.0953C102.929 13.0953 128.905 39.0714 128.905 71C128.905 102.929 102.929 128.905 71 128.905Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0357 49.668H61.8453V55.7632H67.9404V95.3823H55.75V101.478H86.2262V95.3823H74.0357V49.668Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0718 37.4746H67.9766V43.5699H74.0718V37.4746Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.700c426c20b91c4a920911822dc6074e.svg";
export { ForwardRef as ReactComponent };